// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__emdpO","approved":"Status_approved__31Zzr","rejected":"Status_rejected__22Ps7","expired":"Status_expired__jNJ_K","label":"Status_label__aS-Pm"};